import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

const fmtN = (n, dp=0) => Number(n||0).toLocaleString(undefined,{maximumFractionDigits:dp});

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/dashboard/stats.php'),
      api.get('/tiep_goods/list.php'),
    ]).then(([s, t]) => {
      if (s.data.success) setStats(s.data.data);
      if (t.data.success) setRecent(t.data.data.slice(0, 8));
    }).finally(() => setLoading(false));
  }, []);

  const getStatus = t => {
    const pct = t.qty ? (t.issued_qty / t.qty) * 100 : 0;
    if (pct >= 100) return { label:'Exhausted', cls:'badge-red',   pct:100, bar:'#ef4444' };
    if (pct >   70) return { label:'Low Stock',  cls:'badge-amber', pct,     bar:'#f59e0b' };
    return              { label:'Active',      cls:'badge-green', pct,     bar:'var(--teal)' };
  };

  const QUICK = [
    { to:'/add-tiep',    label:'Add TIEP Goods',  bg:'var(--teal)',    icon:'＋' },
    { to:'/issue-goods', label:'Issue Goods',      bg:'#4f46e5',       icon:'↗' },
    { to:'/tiep-goods',  label:'View Stock',       bg:'#0f2544',       icon:'☰' },
    { to:'/mud-form',    label:'MUD Form',         bg:'var(--gold)',    icon:'⎙' },
  ];

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Dashboard</div>
          <div className="page-sub">Overview of TIEP guarantee status</div>
        </div>
        <span style={{ fontSize:11, color:'var(--text2)' }}>{new Date().toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'})}</span>
      </div>

      <div className="page-body" style={{ display:'flex', flexDirection:'column', gap:18 }}>
        {/* Stats */}
        <div className="stats-grid">
          {[
            { label:'Total TIEP Entries', val: loading ? '…' : fmtN(stats?.total_tiep), sub:'All imports', dark:true },
            { label:'Total Liability (LKR)', val: loading ? '…' : fmtN(stats?.total_liability), sub:'Outstanding' },
            { label:'Issue Records', val: loading ? '…' : fmtN(stats?.total_issued), sub:'Export transactions' },
            { label:'Balance Stock', val: loading ? '…' : fmtN(stats?.total_balance), sub:'Units in hand' },
          ].map((s,i) => (
            <div key={i} className={`stat-card ${s.dark ? 'stat-dark' : 'stat-light'}`}>
              <div className="stat-label">{s.label}</div>
              <div className="stat-val">{s.val}</div>
              <div className="stat-sub">{s.sub}</div>
            </div>
          ))}
        </div>

        {/* Quick actions */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12 }}>
          {QUICK.map(q => (
            <Link key={q.to} to={q.to} style={{ background:q.bg, color:'#fff', borderRadius:12, padding:'14px 16px', textDecoration:'none', display:'flex', alignItems:'center', gap:10, fontWeight:600, fontSize:13 }}>
              <span style={{ fontSize:20 }}>{q.icon}</span>{q.label}
            </Link>
          ))}
        </div>

        {/* Recent table */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">Recent TIEP Entries</span>
            <Link to="/tiep-goods" style={{ fontSize:12, color:'var(--teal)', textDecoration:'none', fontWeight:600 }}>View all →</Link>
          </div>
          <div className="tbl-wrap">
            <table>
              <thead><tr>{['Date','Supplier','CUSDEC No','HS Code','QTY','Units','Value LKR','Balance','Status'].map(h=><th key={h}>{h}</th>)}</tr></thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={9} style={{ textAlign:'center', padding:30, color:'var(--text2)' }}>Loading…</td></tr>
                ) : recent.length === 0 ? (
                  <tr><td colSpan={9} style={{ textAlign:'center', padding:30, color:'var(--text2)' }}>No TIEP goods yet. <Link to="/add-tiep" style={{ color:'var(--teal)' }}>Add first entry →</Link></td></tr>
                ) : recent.map(t => {
                  const s = getStatus(t);
                  return (
                    <tr key={t.id}>
                      <td>{new Date(t.date).toLocaleDateString('en-GB')}</td>
                      <td><strong>{t.name}</strong></td>
                      <td className="mono">{t.cusdec_no}</td>
                      <td className="mono">{t.hs_code}</td>
                      <td>{fmtN(t.qty)}</td>
                      <td>{t.units}</td>
                      <td>{fmtN(t.value_usd)}</td>
                      <td><strong style={{ color: t.balance <= 0 ? 'var(--danger)' : 'var(--teal)' }}>{fmtN(t.balance)}</strong></td>
                      <td><span className={`badge ${s.cls}`}>{s.label}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style>{`@media(max-width:900px){.stats-grid{grid-template-columns:repeat(2,1fr)!important} div[style*="repeat(4,1fr)"]{grid-template-columns:repeat(2,1fr)!important}}`}</style>
    </div>
  );
}
